/* Wav Monopoly — lite YouTube facade: load the iframe only on click */
(function () {
  if (window.__wmVideoInit) return;
  window.__wmVideoInit = true;
  document.addEventListener('click', function (e) {
    var frame = e.target.closest('[data-wm-video]');
    if (!frame || frame.dataset.loaded) return;
    var id = frame.getAttribute('data-vid');
    if (!id) return;
    frame.dataset.loaded = '1';
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
    iframe.title = 'Demo video';
    iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;border-radius:16px;';
    frame.innerHTML = '';
    frame.appendChild(iframe);
  });
})();
